<p-toast position="top-right"></p-toast>

<div class="ssr" [class.ssr--loading]="loading">
    <div *ngIf="loading" class="ssr-loader" aria-hidden="true">
        <p-progressSpinner [style]="{width: '36px', height: '36px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
            animationDuration=".5s"></p-progressSpinner>
    </div>

    <div class="ssr-header">
        <h2 class="ssr-title">{{ setLabel('trainersAttendenceLabel') }}</h2>
    </div>

    <div class="ssr-filters">
        <div class="ssr-filter-group">
            <span class="ssr-filter-label">{{ setLabel('searchByMembershipIDLabel') }}</span>
            <input class="ssr-search" [(ngModel)]="tagNumber" autocomplete="off"
                [placeholder]="setLabel('searchHerePlaceholderLabel')" type="number" name="tagNumber">
        </div>
        <div class="ssr-filter-group">
            <span class="ssr-filter-label">{{ setLabel('fromLabel') }}</span>
            <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
                [monthNavigator]="true" [(ngModel)]="from"
                [placeholder]="setLabel('fromDatePlaceholderLabel')"
                dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
                (onSelect)="calenderDateChange()"></p-calendar>
        </div>
        <div class="ssr-filter-group">
            <span class="ssr-filter-label">{{ setLabel('toLabel') }}</span>
            <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
                [monthNavigator]="true" [(ngModel)]="to"
                [placeholder]="setLabel('toDatePlaceholderLabel')"
                dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
                (onSelect)="calenderDateChange()"></p-calendar>
        </div>
        <div class="ssr-actions">
            <button type="button" class="ssr-btn ssr-btn--primary" (click)="search()" [disabled]="loading">
                <i class="pi pi-search" aria-hidden="true"></i>
                <span>Search</span>
            </button>
            <button type="button" class="ssr-btn" (click)="resetFilter()" [disabled]="loading">
                <i class="pi pi-times" aria-hidden="true"></i>
                <span>Clear</span>
            </button>
            <button type="button" class="ssr-btn ssr-btn--print" (click)="printAllInvoice()"
                [disabled]="loading || !isData" [pTooltip]="setLabel('printTooltipLabel')" tooltipPosition="top">
                <i class="pi pi-print" aria-hidden="true"></i>
                <span>{{ setLabel('printTooltipLabel') }}</span>
            </button>
            <button *ngIf="isExportEnabled || (role?.name == 'Super Admin' || role?.name == 'Admin')"
                type="button" class="ssr-btn ssr-btn--export"
                (click)="ExportData(attendecereports, 'Trainer_Attendance_Report')"
                [disabled]="loading || !isData" [pTooltip]="setLabel('exportTooltipLabel')" tooltipPosition="top">
                <i class="pi pi-download" aria-hidden="true"></i>
                <span>{{ setLabel('exportTooltipLabel') }}</span>
            </button>
        </div>
    </div>

    <div class="ssr-table-card">
        <p-table [value]="attendecereports" [paginator]="true" [rows]="100" [responsive]="true" [loading]="loading"
            styleClass="ssr-table" class="p-table-tecfolk-fix">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ setLabel('membershipNoLabel') }}</th>
                    <th>{{ setLabel('photoLabel') }}</th>
                    <th>{{ setLabel('attendanceDateLabel') }}</th>
                    <th>{{ setLabel('attendanceTimeLabel') }}</th>
                    <th>{{ setLabel('trainerNameLabel') }}</th>
                    <th>{{ setLabel('mobileLabel') }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td [attr.data-label]="setLabel('membershipNoLabel')">{{ rowData.membershipNo }}</td>
                    <td [attr.data-label]="setLabel('photoLabel')">
                        <a (click)="openPhoto(rowData.profile,rowData.gender)">
                            <img [alt]="" [src]="rowData.profile
                                ?  config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' + rowData.profile
                                :  rowData.gender && rowData.gender == 'F'
                                ? 'assets/layout/images/avatarGirlImage.png'
                                : 'assets/layout/images/avatarBoyImage.png'"
                                onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" />
                        </a>
                    </td>
                    <td [attr.data-label]="setLabel('attendanceDateLabel')">{{ rowData.start | date: 'fullDate' }}</td>
                    <td [attr.data-label]="setLabel('attendanceTimeLabel')">{{ rowData.start | date: 'shortTime' }}</td>
                    <td [attr.data-label]="setLabel('trainerNameLabel')">{{ rowData.trainerName }}</td>
                    <td [attr.data-label]="setLabel('mobileLabel')">{{ rowData.contact }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="ssr-empty">No records found.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="ssr-summary" *ngIf="attendenceCount != 0">
        <div class="ssr-summary-title">{{ setLabel('summaryLabel') }}</div>
        <div class="ssr-summary-cards">
            <div class="ssr-stat">
                <span class="ssr-stat-label">{{ setLabel('totalCountLabel') }}</span>
                <span class="ssr-stat-value">{{ attendenceCount | number:'1.0-0' }}</span>
            </div>
        </div>
    </div>

    <div *ngIf="imgPreview" (click)="closePhotoPreview()"
            style="position: fixed; top: 0; left: 0; height: 100vh; width: 100vw; z-index: 999999; display: flex; align-items: center; justify-content: center; background: #000000cf;">
            <svg (click)="closePhotoPreview()"
                style="width: 20px; position: absolute; top: 30px; right: 40px; color: #fff; cursor: pointer;"
                aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times"
                class="svg-inline--fa fa-times fa-w-11" role="img" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 352 512">
                <path fill="currentColor"
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                </path>
            </svg>
            <img [src]="imgPreviewImg
            ? config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' +imgPreviewImg
            : 'assets/layout/images/avatarBoyImage.png'" onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
                style="width: 25vw; height: auto;background: #fff;" />
        </div>
</div>

<p-dialog [(visible)]="exportConfirmVisible" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{width: '26rem', maxWidth: '92vw'}">
    <ng-template pTemplate="header">
        <span class="ssr-export-title">{{ setLabel('exportTooltipLabel') }}</span>
    </ng-template>
    <p class="ssr-export-message">Are you sure you want to Export ?</p>
    <ng-template pTemplate="footer">
        <div class="ssr-export-actions">
            <button type="button" class="ssr-btn ssr-btn--cancel" (click)="cancelExport()">Cancel</button>
            <button type="button" class="ssr-btn ssr-btn--confirm" (click)="confirmExport()">
                <i class="pi pi-download" aria-hidden="true"></i>
                <span>{{ setLabel('exportTooltipLabel') }}</span>
            </button>
        </div>
    </ng-template>
</p-dialog>

<div id="allInvoice" style="display: none;">
    <div class="invoice-box">
        <table>
            <tbody>
                <td style="vertical-align: middle;padding: 0px;"><img
                        [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                        alt="Company Logo" style="width: 80%;"> </td>

                <td style="text-align: right;">
                    <div style="width: 438px;">{{branch.name}}</div>
                    <div style="width: 438px;">{{branch.address}}</div>
                    <div>
                        {{setLabel("phoneNo:Label")}} {{branch.phone}}
                    </div>
                    <div>
                        {{setLabel("created:Label")}} {{date | date: 'dd/MM/yyyy'}}
                    </div>
                </td>
            </tbody>
        </table>
        <!-- <div style="display: flex;justify-content: space-between;">
            <div style=" width:40%">
              <img [src]="company.bannerImage == null ? config.Server + 'assets/layout/images/logoCompany.png' : config.Server + company.bannerImage"
                  onerror="this.src='../../../assets/layout/images/aboutlogo.png'"
                  alt="Company Logo" style="width: 70%;">
            </div>
            <div style="text-align: center; width: 36%;">
              <span>{{company.address}}</span> <br/>
                  <div>
                   Phone No: 0{{company.phone}}
                  </div>
                  <div>
                    Created: {{date | date: 'dd/MM/yyyy'}}
                  </div>
            </div>
          </div> -->
        <table cellpadding="0" cellspacing="0">

            <tr class="information">
                <td colspan="4">
                    <table>
                        <tr>
                            <td></td>
                            <td></td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <table style="border-spacing: inherit;" class="tablerpt">
                    <tbody>
                        <tr style="background-color: black;color: white;text-align: center;">

                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("m#Label")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("nameLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("photoLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("dateLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("startTimeLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("endTimeLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("markedByLabel")}}</td>
                            <td style="background-color: black;text-align: center; white-space: nowrap;">{{setLabel("trainerNameLabel")}}
                            </td>
                        </tr>
                        <tr class="item" *ngFor="let item of attendecereports">

                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;border-left: 1px solid gray;">
                                {{item.membershipNo}}</td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                {{item.name}}</td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <img width="60" style="vertical-align: middle;"
                                    src="{{config.Server + 'assets/layout/images/company_' + user.company + '/branch_' + user.branch + '/trainers/' + item.profile}}"
                                    onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" alt="">
                            </td>

                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.end | date: 'fullDate'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.start | date: 'shortTime'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.end | date: 'shortTime'}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;font-size: 11px;vertical-align: middle;">
                                <div *ngFor="let items of item.attendence">
                                    {{items.markedBy}}
                                </div>
                            </td>
                            <td
                                style="text-align: center;    border-bottom: 1px solid gray;border-right: 1px solid gray;vertical-align: middle;font-size: 11px;">
                                {{item.trainerName}}</td>
                        </tr>
                    </tbody>
                </table>
            </tr>
        </table>
        <div style="width: 110px;float: right;">
            <!-- <p>Fee Total: {{totalSales}}</p> -->
        </div>
        <div class="logoDiv">
            {{setLabel("poweredByLabel")}} &nbsp;
            <a href="http://tecfolk.com/" target="_blank"><img style="width:66px;"
                    src="http://tecfolk.com/Content/img/tecfolk-logo-trasprantNormal.png" alt=""></a>
        </div>
    </div>
</div>

<app-email-confirmation-modal [email]="email" [getHtml]="htmlToPdf" [company]="company.name"
    (sendingBackBranchOwnerMail)="sendingBackBranchOwnerMail($event)" [emailConfirmationModal]="emailConfirmationModal"
    (closeEmailComfirmationModal)="closeEmailComfirmationModal()">
</app-email-confirmation-modal>